import { render, staticRenderFns } from "./GenericProductAttributesProductExcelModal.vue?vue&type=template&id=4f5a9360&scoped=true&"
import script from "./GenericProductAttributesProductExcelModal.vue?vue&type=script&lang=js&"
export * from "./GenericProductAttributesProductExcelModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericProductAttributesProductExcelModal.vue?vue&type=style&index=0&id=4f5a9360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5a9360",
  null
  
)

export default component.exports